import { GraphQLClient } from "@xatom/apollo-graphql";
import { publicClient } from "../apollo";

export const publicQL = new GraphQLClient(publicClient);
